import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si mi bebé tiene días de nacido?',
  a: 'Sí — el Tomo 1 y los Bonos 1 y 2 son para los primeros días. Es cuando más impacto produce.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. Email con link de descarga en menos de 5 minutos post-pago.'
}, {
  q: '¿Sirve si ya llevo semanas con dolor?',
  a: 'Sí — el dolor tiene causas específicas con solución técnica en cualquier semana.'
}, {
  q: '¿Qué lo diferencia de los consejos de Instagram?',
  a: 'Protocolos específicos con secuencias exactas — no consejos genéricos. Adaptado al contexto argentino.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días. 100%. Sin preguntas. soporte.mamasinkos@gmail.com'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-60">
      <div className="max-w-3xl mx-auto" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-62">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-cream-light" data-id="element-63">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-darker border border-brand-primary/20 rounded-xl overflow-hidden" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left" data-id="element-66">
                <span className="text-lg font-bold text-brand-cream-light pr-8" data-id="element-67">
                  {faq.q}
                </span>
                {openIndex === i ? <Minus className="w-5 h-5 text-brand-accent shrink-0" data-id="element-68" /> : <Plus className="w-5 h-5 text-brand-primary shrink-0" data-id="element-69" />}
              </button>
              <AnimatePresence data-id="element-70">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} data-id="element-71">
                    <div className="p-6 pt-0 text-brand-primary leading-relaxed" data-id="element-72">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}